import { Icon } from 'modules';
import React, { useState } from 'react';
import DebtModal, { DebtData } from './DebtModal';

interface ButtonEditProps {
  debt: GQL.IDebt;
  onSubmit: (data: DebtData) => void;
}

const ButtonEdit = ({ debt, onSubmit }: ButtonEditProps) => {
  const [showModal, setShowModal] = useState(false);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <Icon type="pen" className="icon-pen-click ml-2" onClick={toggleShowModal} />
      {showModal && <DebtModal data={debt} onHide={toggleShowModal} onSubmit={onSubmit} />}
    </>
  );
};

export default ButtonEdit;
